import { render, staticRenderFns } from "./ArticleListStats.vue?vue&type=template&id=5f1c5948&scoped=true"
import script from "./ArticleListStats.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleListStats.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ArticleListStats.vue?vue&type=style&index=0&id=5f1c5948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1c5948",
  null
  
)

export default component.exports